module.exports = __webpack_public_path__ + "static/icon-lightning-2bdb8cf3cc084fa1536dcf9ddf349255.jpg";